import {
  FETCH_SERVICELINE_FAILURE,
  FETCH_SERVICELINE_LOADING,
  FETCH_SERVICELINE_SUCCESS,
  ADD_SERVICELINE_LOADING,
  ADD_SERVICELINE_SUCCESS,
  ADD_SERVICELINE_FAILURE,
  UPDATE_SERVICELINE_LOADING,
  UPDATE_SERVICELINE_SUCCESS,
  UPDATE_SERVICELINE_FAILURE,
  REMOVE_SERVICELINE_LOADING,
  REMOVE_SERVICELINE_SUCCESS,
  REMOVE_SERVICELINE_FAILURE
} from '../Types/servicelineTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getServicelines = () => {
  return dispatch => {
    dispatch({ type: FETCH_SERVICELINE_LOADING });
    api
      .get(`${API_WP}Serviceline`)
      .then(response => {
        const data = response.data.data;
        dispatch(fetchServicelinesSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchServicelinesError(errorMsg));
      });
  };
};

export const getServicelineByID = id => {
  return dispatch => {
    dispatch({
      type: FETCH_SERVICELINE_LOADING
    });
    api
      .get(`${API_WP}Serviceline/search/${id}`)
      .then(response => {
        var data = response.data.data;
        dispatch(fetchServicelinesSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchServicelinesError(errorMsg));
      });
  };
};

export const fetchServicelinesLoading = () => {
  return {
    type: FETCH_SERVICELINE_LOADING,
    payload: []
  };
};

export const fetchServicelinesSuccess = data => {
  return {
    type: FETCH_SERVICELINE_SUCCESS,
    payload: data
  };
};

export const fetchServicelinesError = error => {
  return {
    type: FETCH_SERVICELINE_FAILURE,
    payload: error
  };
};

export const addServiceLine = serviceLine => {
  return dispatch => {
    dispatch({ type: ADD_SERVICELINE_LOADING });
    api
      .post(`${API_WP}Serviceline/add`, serviceLine)
      .then(response => {
        const data = response.data.data;
        dispatch({ type: ADD_SERVICELINE_SUCCESS, payload: data });
        // dispatch(getServicelines());
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({ type: ADD_SERVICELINE_FAILURE, payload: errorMsg });
      });
  };
};

export const updateServiceLine = (id, serviceLine) => {
  return dispatch => {
    dispatch({ type: UPDATE_SERVICELINE_LOADING });
    api
      .put(`${API_WP}Serviceline/update/${id}`, serviceLine)
      .then(response => {
        const data = response.data.data;
        dispatch({ type: UPDATE_SERVICELINE_SUCCESS, payload: data });
        dispatch(getServicelines());
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({ type: UPDATE_SERVICELINE_FAILURE, payload: errorMsg });
      });
  };
};

export const removeServiceLine = id => {
  return dispatch => {
    dispatch({ type: REMOVE_SERVICELINE_LOADING });
    api
      .delete(`${API_WP}Serviceline/remove/${id}`)
      .then(response => {
        const data = response.data.data;
        dispatch({ type: REMOVE_SERVICELINE_SUCCESS, payload: data._id });
        // dispatch(getServicelines());
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({ type: REMOVE_SERVICELINE_FAILURE, payload: errorMsg });
      });
  };
};

// export const getSubservicelines = (serviceline) => {
//   return dispatch => {
//     dispatch({
//       type: FETCH_SERVICELINE_LOADING
//     });
//     api
//       .get(`${API_WP}Serviceline`)
//       .then(response => {
//         var data = response.data.data;
//         dispatch(fetchServicelinesSuccess(data));
//       })
//       .catch(error => {
//         const errorMsg = error.message;
//         dispatch(fetchServicelinesError(errorMsg));
//       });
//   };
// };
